<template>
  <div id="voice-to-text-default-layout">
    <div id="voice-to-text-component" :class="componentClassName">
      <a-page-heading :id="idName[2]">通話録音テキスト化</a-page-heading>
      <m-section>
        <m-action-card :id="idName2[0]" title="通話録音テキスト化の利用設定" :header-border="true" :narrow-body="true">
          <template #action>
            <a-button
              v-if="showVoiceToTextSettingButton"
              id="voiceToTextEditBtn"
              variant="round"
              size="small"
              label="編集"
              color="grey"
              icon="edit"
              icon-color="black"
              :inline="true"
              @click="handleVoiceToTextSettingEdit"
            />
          </template>
          <a-text id="voice-to-text-setting">{{ voiceToTextSetting }}</a-text>
        </m-action-card>
      </m-section>
      <!-- phone_callモデルで辞書設定を使えるようにGoogleが対応完了したら辞書登録の設定を実装する#3580 -->
      <!-- <m-section>
        <m-action-card :id="idName2[4]" title="キーワードの登録" :header-border="true" :narrow-body="true">
          <a-text
            >{{ explainDictionary1 }} <br />{{ explainDictionary2 }} <br />
            {{ explainDictionary3 }}
          </a-text>
          <div class="t-voice-to-text__keyword-spaceline"></div>
          <li
            v-for="(value, index) in setting.dictionaryPhrases"
            :key="index"
            class="t-voice-to-text-dictionary-registration__row"
          >
            <m-form-input error label="キーワード">
              <a-text-field
                id="t-voice-to-text-existed-phrase"
                v-model="setting.dictionaryPhrases[index]"
                type="text"
                name=""
                placeholder="こんにちは"
                maxlength="20"
                required
                :disabled="authInfo !== 'supervisor'"
              />
            </m-form-input>
            <m-form-input error :label="'テキスト化される確率'">
              <a-radio
                :id="'textProbability' + index + 'low'"
                v-model="setting.dictionaryBoosts[index]"
                class="t-voice-to-text-radio"
                :disabled="authInfo !== 'supervisor'"
                :name="convertToString(setting.dictionaryBoosts[index] + index)"
                value="10"
                variant="button"
                label="低"
              />
              <a-radio
                :id="'textProbability' + index + 'middle'"
                v-model="setting.dictionaryBoosts[index]"
                class="t-voice-to-text-radio"
                :disabled="authInfo !== 'supervisor'"
                :name="convertToString(setting.dictionaryBoosts[index] + index)"
                value="50"
                variant="button"
                label="中"
              />
              <a-radio
                :id="'textProbability' + index + 'high'"
                v-model="setting.dictionaryBoosts[index]"
                class="t-voice-to-text-radio"
                :disabled="authInfo !== 'supervisor'"
                :name="convertToString(setting.dictionaryBoosts[index] + index)"
                value="100"
                variant="button"
                label="大"
              />
              <a-button
                id="t-voice-to-text-delete-existed-dictionary-button"
                :inline="true"
                :disabled="authInfo !== 'supervisor'"
                variant="round"
                color="grey"
                size="small"
                icon="trash"
                label="削除"
                @click="removeDictionaryInput(index)"
              >
              </a-button>
            </m-form-input>
          </li>
          <a-button
            id="t-voice-to-text-add-dictionary-button"
            variant="block"
            color="primary"
            size="small"
            :inline="true"
            :disabled="authInfo !== 'supervisor'"
            @click="addNewDictionaryInput"
          >
            ＋ キーワード追加
          </a-button>
          <div>
            <div class="t-voice-to-text__keyword-spaceline"></div>
            <m-form-action-buttons>
              <a-button
                id="save-button"
                variant="block"
                color="primary"
                :disabled="authInfo !== 'supervisor'"
                @click="handleDictionarySaveClick"
              >
                保存
              </a-button>
              <a-button id="cancel-button" variant="outlined" color="primary" @click="handleCancelClick">
                キャンセル
              </a-button>
            </m-form-action-buttons>
          </div>
        </m-action-card>
      </m-section> -->
    </div>

    <!-- Confirm, Error Modal -->
    <teleport to="body">
      <o-modal
        id="voiceText_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="close-modal-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import OModal from '@/components/organisms/modal';
import MFormInput from '@/components/molecules/form-input';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';

import { customValidate } from '@/common/customValidate.js'; // #2537
import { POINT, voiceToTextSettings } from '@/libs/constants';

import { utils } from '@/common/utils.js';

export default {
  name: 't-voice-to-text',
  components: {
    APageHeading,
    MSection,
    // eslint-disable-next-line vue/no-unused-components
    MFormInput,
    MActionCard,
    AButton,
    AText,
    OModal,
  },
  mixins: [customRequest, customValidate], // #2537
  props: {
    class: {
      type: String,
      default: '',
    },
    // # 2537
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      setting: {
        dictionaryPhrases: [],
        dictionaryBoosts: [],
      },
      voiceToTextOn: false,
      voiceToTextFlg: false,
      idName: [],
      idName2: [],
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,

      // #2537
      authInfo: this.$store.state.user.authInfo,
      explainDictionary1: messageContent.explainDictionary1,
      explainDictionary2: messageContent.explainDictionary2,
      explainDictionary3: messageContent.explainDictionary3,

      trialCompany: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-voice-to-text');
      return `${baseClassName} ${this.class}`.trim();
    },
    currentHelpMessageTitle() {
      if (this.currentHelpType === 'dictionary') {
        return this.dictionaryTitleHelpMessage;
      }
      return '';
    },
    currentHelpMessageText() {
      if (this.currentHelpType === 'dictionary') {
        return this.dictionaryBodyHelpMessage;
      }
      return '';
    },
    voiceToTextSetting() {
      let selectedSetting = voiceToTextSettings[0];
      if (this.voiceToTextOn) {
        for (const setting of voiceToTextSettings) {
          if (!setting.ON) {
            // 1つ目の選択肢はスキップ
            continue;
          } else if (this.voiceToTextFlg === setting.VALUE) {
            selectedSetting = setting;
            break;
          }
        }
      }
      return selectedSetting.LABEL;
    },
    showVoiceToTextSettingButton() {
      return this.authInfo === 'supervisor';
    },
  },
  async created() {
    for (let i = 1; i <= 3; i++) {
      this.idName[i] = 'h1-voicetotext' + i;
    }
    for (let i = 1; i <= 6; i++) {
      this.idName2[i] = 'h4-voicetotext' + i;
    }

    // For Trial
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.trialCompany = true;
    }
    await this.handlerFetchSetting();

    let invalidFlag = false;
    if (this.trialCompany) {
      invalidFlag = true;
    }
    // 通録テキスト化機能（PoC対応）
    if (this.companyID !== POINT && !this.voiceToTextOn) {
      invalidFlag = true;
    }

    if (invalidFlag === true) {
      this.$router.push({ path: '/permission-denied' });
      return;
    }
  },
  mounted() {
    if (this.trialCompany) {
      this.showInfoModal(messageContent.notifyTrialUserCanNotVoiceToText());
    }
  },
  methods: {
    handlerFetchSetting: async function () {
      const self = this;
      await this.postRequest('/voicetotext')
        .then(data => {
          if (data.status === 'success') {
            if (data.data) {
              self.setting.dictionaryPhrases = data.data.dictionaryPhrasesInfo.data
                ? data.data.dictionaryPhrasesInfo.data
                : [];
              self.setting.dictionaryBoosts = data.data.dictionaryBoostsInfo.data
                ? data.data.dictionaryBoostsInfo.data
                : [];
              self.voiceToTextFlg = data.data.voiceToTextFlg ? data.data.voiceToTextFlg : false;
              self.voiceToTextOn = data.data.voiceToTextOn ? data.data.voiceToTextOn : false;
            } else {
              self.setting.dictionaryPhrases = [];
              self.setting.dictionaryBoosts = [];
              self.voiceToTextFlg = false;
              self.voiceToTextOn = false;
            }
          } else {
            self.showErrorModal(messageContent.requireTry('設定の取得'));
          }
        })
        .catch(error => {
          self.showErrorModal(messageContent.requireTry('設定の取得'));
        });
    },
    handleVoiceToTextSettingEdit() {
      this.$router.push({
        name: 'VoiceToTextSettingEdit',
        params: { voiceToTextOnProps: this.voiceToTextOn, voiceToTextFlgProps: this.voiceToTextFlg },
      });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    // #2537
    handleDictionarySaveClick() {
      const self = this;
      for (const k in this.setting.dictionaryPhrases) {
        if (!this.setting.dictionaryPhrases[k]) {
          return self.showErrorModal(messageContent.requireInput('キーワード'));
        }
        if (!this.hasSymbolCharacterInString(this.setting.dictionaryPhrases[k])) {
          return self.showErrorModal(messageContent.requireNotSymbolCharacters('キーワード'));
        }
        if (this.setting.dictionaryPhrases[k].length > 20) {
          return self.showErrorModal(messageContent.requireUnderMaximumNumberOfCharacters('キーワード', '20'));
        }
      }
      if (this.setting.dictionaryPhrases.length > 50) {
        return self.showErrorModal(messageContent.alertUpperLimitExceeded('キーワード', '50'));
      }
      const duplicatedValueArray = this.setting.dictionaryPhrases.filter((x, i, self) => {
        return self.indexOf(x) === i && i !== self.lastIndexOf(x);
      });
      let duplicatedValue;
      if (duplicatedValueArray.length !== 0) {
        for (const k in duplicatedValueArray) {
          if (k === '0') {
            duplicatedValue = '「' + duplicatedValueArray[k] + '」';
          } else {
            duplicatedValue = duplicatedValue + '、' + '「' + duplicatedValueArray[k] + '」';
          }
        }
        return self.showErrorModal(messageContent.alertExistItem(duplicatedValue));
      }
      const dictionaryData = {
        dictionaryPhrases: this.setting.dictionaryPhrases,
        dictionaryBoosts: this.setting.dictionaryBoosts,
      };
      this.postRequest('/voicetotext/saveDictionary', { data: dictionaryData })
        .then(data => {
          if (data.status === 'success') {
            self.showInfoModal(messageContent.dictionarySettingUpdated);
          } else {
            self.showErrorModal(messageContent.requireTry('キーワードの保存'));
          }
        })
        .catch(error => {
          self.showErrorModal(messageContent.requireTry('キーワードの保存'));
        });
      return '';
    },
    addNewDictionaryInput() {
      const self = this;
      if (this.setting.dictionaryPhrases.length >= 50) {
        return self.showErrorModal(messageContent.alertUpperLimitExceeded('キーワード', '50'));
      }
      this.setting.dictionaryPhrases.push('');
      this.setting.dictionaryBoosts.push('50');
      return '';
    },
    removeDictionaryInput(index) {
      this.setting.dictionaryPhrases.splice(index, 1);
      this.setting.dictionaryBoosts.splice(index, 1);
    },
    handleCancelClick() {
      this.$router.push({ name: 'Home' });
    },
    convertToString(value) {
      return value ? value.toString() : '';
    },
  },
};
</script>
